import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import usePostHog from "./hooks/usePostHog";

import { logout, getCurrentUser } from "./services/auth.service";

import Login from "./views/login";
import Home from "./views/home";
import Profile from "./views/profile";
import BoardLast from "./views/last-price";
import BoardFast from "./views/fast-market";
import BoardAdmin from "./views/user-mgmt";
import EventBus from "./common/EventBus";
import BoardParams from "./views/parameters";
import BoardCompliance from "./views/compliance";
import Tolls from "./views/parameters/tolls";
import { MainNavigation } from "./views/main-navigation";
import Logs from "./views/logs";
import NoPermission from "./views/no-permission";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const [showOpBoard, setShowOpBoard] = useState(false);
  const [showAdminBoard, setShowAdminBoard] = useState(false);
  const [currentUser, setCurrentUser] = useState(() => getCurrentUser());
  const [loading, setLoading] = useState(true);
  const { resetIdentity } = usePostHog();

  const logOut = () => {
    setShowOpBoard(false);
    setShowAdminBoard(false);
    setCurrentUser(undefined);
    logout();
  };

  const handleLogOut = () => {
    logOut();
    resetIdentity();
  };

  useEffect(() => {
    const user = getCurrentUser();

    if (user) {
      setCurrentUser(user);
      setShowOpBoard(
        user.roles.some((role) =>
          ["ROLE_OPERATOR", "ROLE_ADMIN"].includes(role)
        )
      );
      setShowAdminBoard(user.roles.includes("ROLE_ADMIN"));
    }

    setLoading(false);

    EventBus.on("logout", () => {
      handleLogOut();
    });

    return () => {
      EventBus.remove("logout");
    };
  }, []);

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center">
        Loading...
      </div>
    );
  }

  return (
    <div className="h-screen flex flex-col">
      <MainNavigation
        currentUser={currentUser}
        showAdminBoard={showAdminBoard}
        showOpBoard={showOpBoard}
        logOut={handleLogOut}
      />
      <div className="overflow-x-auto h-full" id="main_app">
        <Routes>
          <Route
            path="/"
            element={currentUser ? <BoardFast /> : <Navigate to="/login" />}
          />
          <Route
            path="/home"
            element={currentUser ? <Home /> : <Navigate to="/login" />}
          />
          <Route path="/login" element={<Login />} />
          <Route
            path="/profile"
            element={currentUser ? <Profile /> : <Navigate to="/login" />}
          />
          <Route
            path="/last"
            element={
              currentUser ? (
                <BoardLast isad={showOpBoard} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/compliance/:comppage"
            element={
              currentUser ? (
                <BoardCompliance isad={showOpBoard} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/fast"
            element={currentUser ? <BoardFast /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin/parameters/tolls"
            element={currentUser ? <Tolls /> : <Navigate to="/login" />}
          />
          <Route
            path="/admin"
            element={
              currentUser ? (
                showAdminBoard ? (
                  <BoardAdmin />
                ) : (
                  <NoPermission />
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/admin/parameters/:parpage/"
            element={
              currentUser ? (
                showAdminBoard ? (
                  <BoardParams />
                ) : (
                  <NoPermission />
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/admin/parameters/:parpage/:partoedit"
            element={
              currentUser ? (
                showAdminBoard ? (
                  <BoardParams />
                ) : (
                  <NoPermission />
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
          <Route
            path="/logs"
            element={
              currentUser ? (
                showAdminBoard ? (
                  <Logs />
                ) : (
                  <NoPermission />
                )
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </div>
      <ToastContainer
        position="bottom-right"
        hideProgressBar
        closeOnClick
        closeButton={false}
      />
    </div>
  );
};

export default App;
